<app-edtell-ag-grid [config]="agGridConfig"></app-edtell-ag-grid>